module.exports = __webpack_public_path__ + "media/images/sa-shop-9efaa08e2fcc79fe0407b2c8f4fc5905.png";